import { useEffect, useState } from "react";
import DashboardLayout from "../../../hocs/layout/DashboardLayout";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  get_produccion_list,
  get_produccion_list_page,
} from "../../../redux/actions/P03/p03";
import ProduccionList from "../../../components/P03/produccion/ProduccionList";
import { IconFilter, IconSearch } from "@tabler/icons-react";

function ProduccionP03({
  get_produccion_list,
  get_produccion_list_page,
  produccion,
  count,
}) {
  const [turno, setTurno] = useState("");
  const user = useSelector((state) => state.auth.user);
  const [term, setTerm] = useState("");
  const handleChange = (e) => {
    setTerm(e.target.value);
  };

  const handleChangeTurno = (e) => {
    setTurno(e.target.value);
  };
  useEffect(() => {
    if (turno !== "") {
      get_produccion_list(turno);
    } else {
      get_produccion_list();
    } 
  }, [turno]);

  const onSubmit = (e) => {
    e.preventDefault();
    setTimeout(() => (window.location.href = "/produccion-p03/" + term), 0.2);
    setTerm("");
  };
  const refreshData = () => {
    get_produccion_list();
  };

  return (
    <DashboardLayout>
      <div className="border-b border-gray-200 py-5 sm:px-6">
        <div className="flex flex-col flex-wrap lg:flex-row lg:items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-2xl font-medium leading-6 text-gray-900 dark:text-white">
              Lista de Produccion Planta 03.
            </h3>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 py-2 lg:py-0">
            {(user && user.role === "COORDINADOR_PRODUCCION_ENVASADO") ||
            (user && user.role === "COORDINADOR_PLANTA_ENVASADO") ? (
              <div className="flex justify-between gap-4">
                <Link to="/produccion-p03/form">
                  <button className="bg-[#DC2917] text-white px-4 py-1.5 rounded hover:bg-red-800">
                    Agregar Produccion
                  </button>
                </Link>
              </div>
            ) : null}
            <div className="">
              <div className="flex items-center md:max-w-3xl md:mx-auto lg:max-w-none">
                <form onSubmit={(e) => onSubmit(e)} className="w-full">
                  <label htmlFor="search" className="sr-only">
                    Search
                  </label>
                  <div className="relative">
                    <button
                      type="submit"
                      className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
                    >
                     <IconSearch stroke="#0096C4" />
                    </button>
                    <input
                      id="search"
                      name="search"
                      required
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      className="block w-full bg-white dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 border border-gray-300 dark:border-gray-600 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      placeholder="Buscar"
                      type="search"
                    />
                  </div>
                </form>
              </div>
            </div>

            <div className="dropdown dropdown-end">
              <div
                tabIndex={0}
                role="button"
                className="p-1.5 bg-white dark:bg-gray-700 border border-[#0096C4] rounded"
              >
                <IconFilter stroke="#0096C4" />
              </div>
              <div
                tabIndex={0}
                className="dropdown-content z-[1] menu p-4 shadow bg-base-100 dark:bg-gray-800 rounded-box w-52"
              >
                <div className="flex flex-col gap-y-2">
                  <label className="form-control w-full max-w-xs">
                    <div className="label">
                      <span className="label-text text-gray-900 dark:text-gray-300">
                        Turno
                      </span>
                    </div>
                    <select
                      onChange={handleChangeTurno}
                      value={turno}
                      className="select select-bordered w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    >
                      <option value="">Elige una opción</option>
                      <option value="A">Diurno</option>
                      <option value="B">Nocturno</option>
                    </select>
                  </label>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
     
      </div>
      <ProduccionList
        produccion={produccion}
        count={count}
        get_produccion_list_page={get_produccion_list_page}
        refreshData={refreshData}
        user={user}
      />
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ({
  produccion: state.produccion.producciones,
  count: state.produccion.count,
});

export default connect(mapStateToProps, {
  get_produccion_list,
  get_produccion_list_page,
})(ProduccionP03);
